var clamp = function(t, e, n) {
  return t < e ? e : t > n ? n : t;
};

export { clamp };
